// function initInputmask() {
//   if (document.querySelectorAll(".mask-phone-js") != null) {
//     let phone = document.querySelectorAll(".mask-phone-js");
//     let phonePlaceholder = document.querySelectorAll(
//       ".mask-phone-placeholder-js"
//     );
//     let mailMask = document.querySelectorAll(".mask-mail-js");
//
//     let maskOptionsPhone = {
//       mask: "+{7}(000)000-00-00",
//       lazy: false,
//     };
//     let maskOptionPhonePlaceholder = {
//       mask: "+{7}(000)000-00-00",
//     };
//     let maskOptionsMail = {};
//     mailMask.forEach(function (itemMail) {
//       let mask = IMask(itemMail, maskOptionsMail);
//     });
//     phone.forEach(function (itemPhone) {
//       let mask = IMask(itemPhone, maskOptionsPhone);
//     });
//     phonePlaceholder.forEach(function (itemPhonePlaceholder) {
//       let mask = IMask(itemPhonePlaceholder, maskOptionPhonePlaceholder);
//     });
//   }
// }
function initInputmask() {
    const phoneInputs = document.querySelectorAll(".mask-phone-js");
    const emailInputs = document.querySelectorAll(".mask-mail-js");

    // Маска для телефона
    const maskOptionsPhone = {
        mask: "+{7}(000)000-00-00", // Формат номера телефона
        lazy: false, // Показывать маску даже для пустого поля
    };

    // Применяем маску для полей "Номер телефона"
    if (phoneInputs.length) {
        phoneInputs.forEach((phoneInput) => {
            IMask(phoneInput, maskOptionsPhone);
        });
    }

    // Логика для поля E-mail
    if (emailInputs.length) {
        emailInputs.forEach((emailInput) => {
            // Обработчик для запрета ввода кириллицы
            emailInput.addEventListener("input", (event) => {
                if (/[^a-zA-Z0-9._%+-@]/.test(event.data)) {
                    // Удаляем недопустимые символы
                    emailInput.value = emailInput.value.replace(/[^a-zA-Z0-9._%+-@]/g, "");
                }
            });

            // Обработчик для проверки валидности E-mail
            emailInput.addEventListener("blur", () => {
                const errorMessage = emailInput.nextElementSibling;
                const emailValue = emailInput.value.trim(); // Убираем пробелы

                if (emailValue === "") {
                    // Если поле пустое, не добавляем классы
                    emailInput.classList.remove("invalid-inp");
                    errorMessage.textContent = ""; // Убираем сообщение об ошибке
                } else if (!emailValue.includes("@") || !emailValue.includes(".")) {
                    // Если E-mail некорректный
                    emailInput.classList.add("invalid-inp");
                    errorMessage.textContent = "E-mail должен содержать '@' и '.'";
                } else {
                    // Если E-mail корректный
                    emailInput.classList.remove("invalid-inp");
                    errorMessage.textContent = "";
                }
            });

            // Обработчик для динамического подсвечивания поля
            emailInput.addEventListener("input", () => {
                const emailValue = emailInput.value;

                if (!emailValue.includes("@") || !emailValue.includes(".")) {
                    emailInput.classList.add("invalid-inp");
                    emailInput.classList.remove("valid-inp");
                } else {
                    emailInput.classList.remove("invalid-inp");
                    emailInput.classList.add("valid-inp");
                }
            });
        });
    }
}

// Запуск функции после загрузки страницы
document.addEventListener("DOMContentLoaded", () => {
    initInputmask();
});
